import { MutationTree } from 'vuex'

import _get from 'lodash/get'
import _find from 'lodash/find'
import _findIndex from 'lodash/findIndex'

import { SellersState } from './types'
import { state as initialState } from './index'
import { Seller, OfferItem } from '../../types'

export const mutations: MutationTree<SellersState> = {
  reset(state) {
    Object.keys(initialState).forEach(key => {
      state[key] = initialState[key]
    })
  },
  resetRequest(state) {
    Object.keys(initialState).forEach(key => {
      if (key.indexOf('request') === 0 || key === 'error') {
        state[key] = initialState[key]
      }
    })
  },
  setEditSeller(state, payload: { seller: Seller | null }) {
    state.editSeller = payload.seller
  },
  setActiveSeller(state, payload: { seller: Seller | null }) {
    state.activeSeller = payload.seller
  },
  setError(state, payload) {
    state.error = payload
  },
}
